module.exports = __webpack_public_path__ + "media/ko_kr_s2_HaJoon.f55da818.oga";